import { Component, Input, OnInit } from "@angular/core";
import { AdressService } from "src/app/services/address/adress.service";
import { RouterService } from "src/app/services/router/router.service";
import { Platform } from "@ionic/angular";
import { AlertService } from "src/app/services/alert/alert.service";
import { AlertController } from "@ionic/angular";
import { LanguagesService } from 'src/app/services/languagesService/languages.service';
import { ActivatedRoute } from "@angular/router";
import { CredentialsService } from "src/app/services/credentials/credentials.service";
import { ICheckout } from "src/app/interfaces/IShoppingCart";
import { ShoppingCartService } from "src/app/services/shopping-cart/shopping-cart.service";
import { StorageService } from "src/app/services/storage/storage.service";
import { AuthService } from "src/app/services/auth/auth.service";
import { UserService } from "src/app/services/user/user.service";

@Component({
  selector: 'app-list-address',
  templateUrl: './list-address.page.html',
  styleUrls: ['./list-address.page.scss'],
})
export class ListAddressPage implements OnInit {
  edit = false;
  lang: string;
  userAddress: [] = [];
  userAddressFormated: any = [];
  adressSelected: any;
  noAddress = false;
  fromShoppingCart = false;
  activeAdress;
  userInfo: any = {};

  public form = [
       { val: 'Pepperoni', isChecked: true },
       { val: 'Sausage', isChecked: false },
       { val: 'Mushroom', isChecked: false }
     ];
  constructor(
    private route: ActivatedRoute,
    private adressService: AdressService,
    private routerService: RouterService,
    public alertService: AlertService,
    public platform: Platform,
    private alertController: AlertController,
    public languageService: LanguagesService,
    private credentialsService: CredentialsService,
    private shoppingCartService: ShoppingCartService,
    private localStorage: StorageService,
    private authService: AuthService,
    private userService: UserService) { }
    
    ionViewWillEnter() {
      this.getActiveAdress();
      this.route.queryParams.subscribe((params) => {
        if(params.data){
          this.fromShoppingCart = JSON.parse(params.data).fromShoppingCart;
        }
      });
    }
    
    async ngOnInit() {
      this.getAddressUser();
      this.getActiveAdress();
      this.lang = this.languageService.language;

      const userFirebase = await this.authService.getUSerInfoFromFirebase();
      const { email, phone, username} = await this.localStorage.get("gnx-claims");
      const dataname =  await this.localStorage.get('gnx-personal-data');
      const name = dataname?.name
      const lastName = dataname?.last_name
      const emailFirebase = userFirebase.email.split('@')[1] == 'nomail.glukynet.com' ? '' : userFirebase.email;
      this.userInfo = {
        name: name ?? "",
        lastname: lastName ?? "",
        docId: dataname?.iddoc,
        email: emailFirebase || email,
        phone: (userFirebase.phoneNumber) ? (userFirebase.phoneNumber.replace("+57", "").replace("+52", "") || phone) : '',
        phone2: "",
        username: username
      };

    }
    async getAddressUser() {
      this.adressService.getAllAdress().subscribe((res: any) => {
        if (res.address && res.activeAddress) {
          this.userAddress = res.address;
          this.adressSelected = res.activeAddress;
        } else {
          this.noAddress = true;
        }
      });
    }

    changeColorToSelectedAdress(address) {
      if (this.edit) {
        return "card-address no-selected";
      }
      if (!this.adressSelected) {
        this.adressSelected = address;
        this.adressService.setActiveAdresss(this.adressSelected);
      }

      if (Object.keys(this.adressSelected).length > 0) {
        if (address.uid === this.adressSelected.uid) {
          return "card-address selected";
        }
        return "card-address no-selected";
      }
      return "card-address no-selected";
    }
    selectAdress(address) {
      this.adressSelected = address;
      this.adressService.setActiveAdresss(address);
      this.getActiveAdress();
    }
    goToAddNewAdress() {
      if (this.fromShoppingCart) {
        this.routerService.redirectRootWithdata('app/map/add-address', { fromShoppingCart: true })
      } else {
        this.routerService.redirectRoot(`app/map/add-address`);
      }
    }

    editAddress(address) {
      console.log("edit no se usa");
    }

    async deleteAddress(address) {
      this.adressService.removeAdress(address);
      this.adressService.unsetActiveAdress(address);
      this.getActiveAdress();

      const checkoutData  = await this.localStorage.get('checkoutData');
      if((checkoutData.address.name == address.name) && (checkoutData.address.addressLine1 == address.addressLine1)){
        let body = checkoutData;
        delete body.address;
        this.shoppingCartService.checkoutData(body).then(async (res) => {
          await this.localStorage.set('checkoutData', res.checkoutData);
        })
      }
    }

    async showAlert(address) {
      return new Promise(async (resolve) => {
        const alert = await this.alertController.create({
          message: `${this.languageService.textsIU.page_maps.alert_message}, ${address.name} ${address.addressLine1}`,
          buttons: [
            {
              text: `${this.languageService.textsIU.page_maps.cancel_button}`,
              role: "cancel",
              cssClass: "secondary",
              handler: (_) => { },
            },
            {
              text: `${this.languageService.textsIU.page_maps.ok_button}`,
              handler: async () => {
                this.deleteAddress(address)
                resolve(true);
              },
            },
          ],
        });
        await alert.present();
      });
    }

    credentialsOrders = () => {
      return this.credentialsService.orders();
    };

    get getTextIUAddress() {
      return this.languageService.textsIU.page_maps;
    }

    async goShoppingCart(){
      const checkoutData  = await this.localStorage.get('checkoutData');
      const { companyId, programId, appId } = this.credentialsOrders();
      await this.adressService.getAllAdress().subscribe((res: any) => {
        this.activeAdress = res.activeAddress;
        if(typeof this.activeAdress.postalCode === 'object'){
          this.activeAdress.postalCode = this.activeAdress.postalCode.code;
        }
      });
      let body: ICheckout = {
        companyId,
        programId,
        appId,
        user: this.userInfo,
        address: this.activeAdress
      }
      if(checkoutData){
        body = checkoutData;
        body.companyId = companyId;
        body.programId = programId;
        body.appId = appId;
        body.user = this.userInfo;
        body.address = this.activeAdress
      }
      if(!body.user.email){
        delete body.user.email;
      }
      this.shoppingCartService.checkoutData(body).then(async (res) => {
        await this.localStorage.set('checkoutData', res.checkoutData);
        this.routerService.redirectRoot(`/app/shopping-cart`);
      })
    }

    getActiveAdress = async () => {
      this.activeAdress = { test: "test" }; //temporal data
      (await this.adressService.getAllAdress()).subscribe((info: any) => {
        this.activeAdress = info.activeAddress;
        if(typeof this.activeAdress.postalCode === 'object'){
          this.activeAdress.postalCode = this.activeAdress.postalCode.code;
        }
      });
    };

}
